export const CatalogCourses = {
    template: `
        <div>list courses</div>
    `
}